import { useSelector } from "react-redux";
import useCheckCallConnected from "../../hooks/useCheckCallConnected";
import useLanguageChange from "../../hooks/useLanguageChange";
import uploadFilesService from "../../services/uploadFilesService";
import googleEvent from "../../services/googleEvent";
import measurementService from "../../services/measurementService";
import livePointerService from "../LivePointer/livePointerService";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import { HELP_ARTICLE } from "../../constants/LDConstants";
import { DISABLE, ENABLED, ROOM_TYPE, DEVICE_TYPES } from "../../constants/Constants";
import { STATUS } from "../../constants/LivePointerConstants";
import { dualStreamEnabled } from "../../shared/utility";
import { sendMsgForPointer } from "../../shared/dataTrackFunction";
import { setIsAppDownloadModalOpenForMeasurement } from "../../reducers/measurement-reducer";
import reduxStore from "../../configureEnvStore";
import { EVENT_NAME } from "../../constants/GTagConstants";
import { LogFirebase } from "../../services/firestore";

const MeasurementButton = () => {
    const isCallNotConnected = useCheckCallConnected();
    const { isRoomConnected, isRemoteParticipantJoined } = useSelector((state) => state.commonReducer);
    const { streamingPartiIdentity, streamingDetails, isOpponentUserScreenSharing, startLocalVideo } = useSelector((state) => state.twilioEvents);
    const { pointerOn } = useSelector((state) => state.livePointer);
    const { disabledMeasurementButton } = useSelector((state) => state.measurement);
    const localisedValues = useLanguageChange();

    const isMeasurementButtonDisabled = () => {
        return checkMeasurementButton() || disabledButtonForWebMweb() || disabledMeasurementButton;
    };

    const checkMeasurementButton = () => {
        if (!isCallNotConnected) {
            if (!uploadFilesService.isUploadFilesView()) {
                if (!dualStreamEnabled()) {
                    return isOpponentUserScreenSharing;
                }
            } else {
                return true;
            }
        } else {
            return true;
        }
    };

    const disabledButtonForWebMweb = () => {
        if (GLOBAL_MEETING_DATA.ucid) {
            if (streamingPartiIdentity !== null) {
                const supportedDevices = [DEVICE_TYPES.ANDROID_BROWSER, DEVICE_TYPES.IOS_BROWSER, DEVICE_TYPES.DESKTOP];
                return supportedDevices.includes(streamingDetails.device_type);
            } else {
                return false;
            }
        }
        return false;
    };

    // Disabled measurement button for mweb guest
    const disableButtonForMwebGuest = function () {
        return !(isRoomConnected && GLOBAL_MEETING_DATA.isGuest && PublicVariables.isMobile && startLocalVideo && isRemoteParticipantJoined);
    };

    const startMeasurement = () => {
        if (isRoomConnected && GLOBAL_MEETING_DATA.isAgent) {
            if (pointerOn) {
                livePointerService.turnOffLivePointer();
                sendMsgForPointer(STATUS.OFF);
            }
            setTimeout(() => {
                googleEvent.logEvent(EVENT_NAME.MEASUREMENT_TAPPED);
                measurementService.startMeasurement();
            }, 200);
        }
    };

    const openMeasurementPopupForGuest = () => {
        reduxStore.dispatch(setIsAppDownloadModalOpenForMeasurement(true));
        LogFirebase("MwebMeasurement", "popup", "Opened");
        googleEvent.logEvent(EVENT_NAME.MWEB_MEASUREMENT_POPUP_OPNED);
    };

    const appRequiredHTMLText = localisedValues?.app_required?.replace(
        /<learnmore>/g,
        `<a class='text-dec-none' target='_blank' href='${HELP_ARTICLE.MEASUREMENT_APP_ARTICLES_NUMBER}' rel='noreferrer'> ${localisedValues?.learn_more} </a>`
    );

    return (
        <>
            {GLOBAL_MEETING_DATA.isAgent &&
                PublicVariables.featureFlag?.ARMEASUREMENT === ENABLED &&
                PublicVariables.featureFlag.SHOWMEDUALSTREAM == DISABLE && (
                    <div className='action-button' data-testid='measure-button-div-agent'>
                        <div className='action-button-in custom-tooltip top-tooltip left-tooltip tooltip-auto-width'>
                            <button
                                className='call-action-btn'
                                disabled={isMeasurementButtonDisabled()}
                                onClick={startMeasurement}
                                data-testid='measurement-button'
                            >
                                <span className='action-button-icon'>
                                    <span className='for-icon icon-ar-measure'></span>
                                    <span className='beta-label'>Beta</span>
                                </span>
                                <span className='for-text'>{localisedValues?.measure}</span>
                            </button>
                            {isMeasurementButtonDisabled() && (
                                <div className='custom-tooltip-content text-nowrap'>
                                    <div className='custom-tooltip-in'>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: appRequiredHTMLText,
                                            }}
                                        ></p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            {GLOBAL_MEETING_DATA.isGuest &&
                PublicVariables.isMobile &&
                PublicVariables.featureFlag?.ARMEASUREMENT === ENABLED &&
                PublicVariables.featureFlag?.SHOWMEDUALSTREAM == DISABLE &&
                PublicVariables.featureFlag?.SHOWMEROOMTYPE !== ROOM_TYPE.GO && (
                    <div className='action-button' data-testid='measurement-component-guest'>
                        <div className='action-button-in custom-tooltip top-tooltip left-tooltip tooltip-auto-width'>
                            <button
                                className='call-action-btn'
                                disabled={disableButtonForMwebGuest()}
                                onClick={openMeasurementPopupForGuest}
                                data-testid='measurement-button-guest'
                            >
                                <span className='action-button-icon'>
                                    <span className='for-icon icon-ar-measure'></span>
                                    <span className='beta-label'>Beta</span>
                                </span>
                                <span className='for-text'>{localisedValues?.measure}</span>
                            </button>
                        </div>
                    </div>
                )}
        </>
    );
};

export default MeasurementButton;
